import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  viewBox: "0 0 81 80",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, _cache[0] || (_cache[0] = [
    _createElementVNode("circle", {
      cx: "40.5",
      cy: "40",
      r: "40",
      fill: "#F4F4F4"
    }, null, -1),
    _createElementVNode("path", {
      d: "M62.034 39.9955C62.034 28.1001 52.3909 18.457 40.4955 18.457C28.6001 18.457 18.957 28.1001 18.957 39.9955C18.957 51.8909 28.6001 61.534 40.4955 61.534",
      stroke: "#00AAC0",
      "stroke-width": "3"
    }, null, -1)
  ])))
}
export default { render: render }